import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import {  CapitoloBilancio } from '../models';


class DataTablesResponse {
    data: CapitoloBilancio[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Injectable({
    providedIn: "root"
})
export class CapitoloBilancioService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}CapitoliBilancio/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<DataTablesResponse>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    
    getAll(filter:any) {
        return this.http.get<CapitoloBilancio[]>(
            `${this.apiUrl}?filter=${filter?filter:null}`
        );
    }
    insert(s: CapitoloBilancio) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: CapitoloBilancio) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:CapitoloBilancio){
        if (s.id)return this.update(s);
        return this.insert(s);
    }

}
